//@ts-nocheck
"use client";

import { ReactNode, useEffect } from "react";
import useGAPageView from "./utils/useGAPageView";

const ClientWrapper = ({ children }: { children: ReactNode }) => {
  useGAPageView();

  useEffect(() => {
    // Custom engaged_time event every 30 seconds
    const interval = setInterval(() => {
      window.gtag?.("event", "engaged_time", {
        engagement_time_msec: 30000,
      });
    }, 30000);

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return <>{children}</>;
};

export default ClientWrapper;
